var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
var TabGroupWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background: ", ";\n  padding: 32px 16px 0;\n  display: flex;\n  flex-direction: row;\n  list-style: none;\n  margin: 0;\n"], ["\n  ", "\n  background: ", ";\n  padding: 32px 16px 0;\n  display: flex;\n  flex-direction: row;\n  list-style: none;\n  margin: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.cell;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorsNew.gray.grayLight;
});
/**
 *
 * Wraps a group of `Tab` accessibly according to WAI-ARIA guidelines.
 * @see [This WAI-ARIA example](https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-1/tabs.html).
 */
export function TabGroup(_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(TabGroupWrapper, __assign({}, rest, { role: "tablist" }), children));
}
var templateObject_1;
